/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TypeTunnel } from './TypeTunnel';
import {
    TypeTunnelFromJSON,
    TypeTunnelFromJSONTyped,
    TypeTunnelToJSON,
    TypeTunnelToJSONTyped,
} from './TypeTunnel';

/**
 * Corps entièrement optionnel de la duplication. Sans code, le back génère « {code source}-COPIE » (puis -COPIE-2, -COPIE-3… si déjà pris) ; sans libellé, « {libellé source} (copie) ».
 * 
 * @export
 * @interface DupliquerTunnelCommand
 */
export interface DupliquerTunnelCommand {
    /**
     * Code du tunnel copié. Doit être libre : un code déjà utilisé fait échouer la duplication (le back ne corrige pas en silence, le code identifie le tunnel partout — API partenaires, imports, paramétrage).
     * 
     * @type {string}
     * @memberof DupliquerTunnelCommand
     */
    code?: string | null;
    /**
     * Désignation du tunnel copié.
     * @type {string}
     * @memberof DupliquerTunnelCommand
     */
    label?: string | null;
    /**
     * Individuel ou Collectif. Absent = type de la source (cas courant). Le changer a une conséquence : les supports incompatibles avec le type demandé (SOLO sur un Collectif, GROUP / CADRE sur un Individuel) ne sont pas repris, et notCopied les énumère.
     * @type {TypeTunnel}
     * @memberof DupliquerTunnelCommand
     */
    tunnelType?: TypeTunnel | null;
}



/**
 * Check if a given object implements the DupliquerTunnelCommand interface.
 */
export function instanceOfDupliquerTunnelCommand(value: object): value is DupliquerTunnelCommand {
    return true;
}

export function DupliquerTunnelCommandFromJSON(json: any): DupliquerTunnelCommand {
    return DupliquerTunnelCommandFromJSONTyped(json, false);
}

export function DupliquerTunnelCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): DupliquerTunnelCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'label': json['label'] == null ? undefined : json['label'],
        'tunnelType': json['tunnelType'] == null ? undefined : TypeTunnelFromJSON(json['tunnelType']),
    };
}

export function DupliquerTunnelCommandToJSON(json: any): DupliquerTunnelCommand {
    return DupliquerTunnelCommandToJSONTyped(json, false);
}

export function DupliquerTunnelCommandToJSONTyped(value?: DupliquerTunnelCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'label': value['label'],
        'tunnelType': TypeTunnelToJSON(value['tunnelType']),
    };
}

